import React, { useEffect, useState, useCallback } from 'react';
import styles from './netwatcher.module.scss';
import { inWindow } from 'api';
import { getIn18Text } from 'api';
export const useNetStatus = () => {
    const [online, setOnline] = useState(inWindow() ? window.navigator.onLine : true);
    const changeNetStatusOnline = useCallback(() => {
        setOnline(!0);
    }, []);
    const changeNetStatusOffline = useCallback(() => {
        setOnline(false);
    }, []);
    useEffect(() => {
        window.addEventListener('online', changeNetStatusOnline);
        window.addEventListener('offline', changeNetStatusOffline);
        return () => {
            window.removeEventListener('online', changeNetStatusOnline);
            window.removeEventListener('offline', changeNetStatusOffline);
        };
    }, [changeNetStatusOffline, changeNetStatusOnline]);
    return online;
};
const NetWatcher = ({ children }) => {
    return null;
    const online = useNetStatus();
    if (online) {
        return null;
    }
    if (children) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement("div", { className: styles.netwatcherWrapper, "data-test-id": "mail-net-error-bar" },
        React.createElement("span", { className: styles.wifiIcon }),
        React.createElement("span", null, getIn18Text('WANGLUOYICHANG~'))));
};
export default NetWatcher;
